import { leaveLimitMessage } from 'src/app/Service/Person/PersonLeaveLimitSettings.service';
import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Empty_Persone_List_Interface, Persone_List_Interface } from 'src/app/Interface/Persone_List_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { PersonOffTimeService } from 'src/app/Service/Person/PersonOffTime.service';

@Component({
  selector: 'app-PersonOffTimeAdd',
  templateUrl: './PersonOffTimeAdd.component.html',
  styleUrls: ['./PersonOffTimeAdd.component.css']
})
export class PersonOffTimeAddComponent implements OnInit {

  HourList=[]
  MinList=[]

  constructor(
    private PersonOff_Service: PersonOffTimeService,

    private Nav_Service: NavService,
    private Alertify_Service: AlertifyService,

  ) { }

  ngOnInit() {

    this.HourList=Array(24).fill(1).map((x, i) => i);
    this.MinList=Array(60).fill(1).map((x, i) => i);

    this.AddNewOfftime = new FormGroup({
      id: new FormControl(),
      endDate_Min: new FormControl("0"),
      endDate_Hour: new FormControl("0"),
      startDate_Min: new FormControl("0"),
      startDate_Hour: new FormControl("0"),
      requestDate: new FormControl(),
      dsc: new FormControl(null, Validators.required),
    })


    this.Nav_Service.CheckValidPage(2209).subscribe(
      data => {

      }
      , error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )


  }


  //#region  Form Add

  AddNewOfftime: FormGroup;



  get_Form_requestDate() {
    return this.AddNewOfftime.get('requestDate') as FormControl;
  }

  get_Form_dsc() {
    return this.AddNewOfftime.get('dsc') as FormControl;
  }

  get_Form_endDate_Hour() {
    return this.AddNewOfftime.get('endDate_Hour') as FormControl;
  }
  get_Form_endDate_Min() {
    return this.AddNewOfftime.get('endDate_Min') as FormControl;
  }
  get_Form_startDate_Min() {
    return this.AddNewOfftime.get('startDate_Min') as FormControl;
  }
  get_Form_startDate_Hour() {
    return this.AddNewOfftime.get('startDate_Hour') as FormControl;
  }

  //#endregion




  InProccessing: boolean = false


  SubmitAddNewOfftime() {
    if (this.InProccessing) return;
    this.InProccessing = true
    this.PersonOff_Service.AddOfftime(
      this.get_Form_startDate_Hour().value+':'+this.get_Form_startDate_Min().value,
      this.get_Form_endDate_Hour().value+':'+this.get_Form_endDate_Min().value,
      this.get_Form_dsc().value,
      this.get_Form_requestDate().value).subscribe(
        data => {
          this.InProccessing = false
          if (data.id == -2) {
            this.Alertify_Service.ErrorMessage("در این بازه برای شما درخواستی ثبت شده است")
          }
          else if (data.id == -1) {
            this.Alertify_Service.ErrorMessage("بازه مرخصی، بررسی نمائید.")
          }
          else if (data.id == -3) {
            this.Alertify_Service.ErrorMessage("گردش کار فعالی برای مرخصی ساعتی انتخاب نشده است")
          }
          else if (data.id == -4) {
            this.Alertify_Service.ErrorMessage("خطا سیستمی")
          }
          else if (data.id == -5) {
            this.Alertify_Service.ErrorMessage("در چارت سازمانی بدون سمت هستید")
          }
          else {

            this.AddNewOfftime.reset()

            this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
          }
        }, error => {
          this.InProccessing = false;
          this.Alertify_Service.ErrorMessage(leaveLimitMessage(error));

        }
      )
  }

}
